import { render, staticRenderFns } from "./create.vue?vue&type=template&id=23350bcc&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23350bcc')) {
      api.createRecord('23350bcc', component.options)
    } else {
      api.reload('23350bcc', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=23350bcc&", function () {
      api.rerender('23350bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/users/create.vue"
export default component.exports